export enum TranskodeFieldOrder {
  Interlaced = "Interlaced",
  Progressive = "Progressive",
}
